<template>
  <v-autocomplete
    :class="{ 'pt-0': noStyle, 'mt-0': noStyle }"
    v-model="dealer"
    :items="dealerOptions"
    :menu-props="{ maxHeight: '400' }"
    @input.native="loadDealers()"
    :search-input.sync="dealerSearch"
    :label="label"
    persistent-hint
    color="primary"
    clearable
    :hint="hint"
    :rules="rule"
    :disabled="disabled || isDisabled"
    autocomplete="off"
    return-object
    item-text="name"
    item-disabled="partner_status"
    no-filter
    @change="handleChange"
  >
    <template v-slot:item="{ item }">
      <span>{{ item.name }}</span>
      <v-spacer></v-spacer>
      <v-chip v-if="item.partner_status">{{
        $t("components.selectors.dealerSelector.inactive")
      }}</v-chip>
    </template>
    <template v-slot:selection="{ item }">
      <span>{{ item.name }}</span>
      <v-spacer></v-spacer>
      <v-chip v-if="item.partner_status">{{
        $t("components.selectors.dealerSelector.inactive")
      }}</v-chip>
    </template>
  </v-autocomplete>
</template>

<script>
import api from "@/utils/api";
import debounce from "@/plugins/debounce";
import { mapGetters } from "vuex";

export default {
  props: {
    initialDealerUuid: {
      type: String,
      default: String,
    },
    initialDealer: {
      type: Object,
      default: Object,
    },
    loadDealersExternal: {
      type: Boolean,
      default: Boolean,
    },
    dealerType: {
      type: String,
      default: String,
    },
    label: {
      type: String,
      default: String,
    },
    noStyle: {
      type: Boolean,
      default: Boolean,
    },
    selectFirst: {
      type: Boolean,
      default: Boolean,
    },
    hint: {
      type: String,
      default: String,
    },
    rule: {
      type: Array,
      default: Array,
    },
    disabled: {
      type: Boolean,
      default: Boolean,
    },
    tasks: {
      type: Boolean,
      default: Boolean,
    },
  },

  data: () => ({
    dealerOptions: [],
    dealerSearch: "",
    dealer: {},
    timeout: null,
    isDisabled: false,
  }),
  created() {
    if (
      typeof this.initialDealer === "object" &&
      this.initialDealer !== null &&
      Object.keys(this.initialDealer).length !== 0 &&
      this.initialDealer.name !== ""
    ) {
      this.dealerOptions.push(this.initialDealer);
    }

    this.loadDealers(true)
      .then((resp) => {
        if (this.initialDealerUuid.length !== 0) {
          let dealer = this.dealerOptions.find((element) => {
            return element.uuid === this.initialDealerUuid;
          });

          if (
            typeof dealer === "undefined" &&
            Object.keys(this.initialDealer).length !== 0
          ) {
            this.dealerOptions = [...this.dealerOptions, this.initialDealer];
            this.dealer = this.initialDealer;
          } else {
            this.dealer = dealer;
          }
        }
      })
      .catch(() => {
        if (
          typeof this.initialDealer === "object" &&
          this.initialDealer !== null &&
          Object.keys(this.initialDealer).length !== 0 &&
          this.initialDealerUuid.name !== ""
        ) {
          this.dealerOptions = [...this.dealerOptions, this.initialDealer];
          this.dealer = this.initialDealer;
        }
      });
  },
  computed: {
    ...mapGetters(["getMe"]),
  },
  methods: {
    handleChange(value = {}) {
      if (Object.keys(value).length !== 0) {
        this.$emit("change", value);
      } else {
        this.$emit("change", {});
      }
    },
    loadDealers(initalLoad = false) {
      let fetchDealers = () => {
        return new Promise((resolve, reject) => {
          this.dealerSearch = this.dealerSearch ? this.dealerSearch : "";
          let params = {
            search: this.dealerSearch,
          };

          if (typeof this.tasks !== "undefined" && this.tasks === true) {
            params.purpose = "task_assignment";
          }
          if (
            this.loadDealersExternal &&
            (Object.keys(this.dealer).length !== 0 ||
              this.initialDealerUuid.length !== 0)
          ) {
            params.purpose = "partner_assignment";
            params.current_partner_uuid =
              Object.keys(this.dealer).length !== 0 &&
              typeof this.dealer.uuid !== "undefined"
                ? this.dealer.uuid
                : this.initialDealerUuid;
          }

          api
            .dealersAutocomplete(params, false)
            .then((resp) => {
              this.dealerOptions = resp.data.results.map((element) => {
                return {
                  ...element,
                  partner_status: element.partner_status === "INACTIVE",
                };
              });

              if (this.selectFirst) {
                this.dealer = this.dealerOptions[0].uuid;
              }

              //this.isDisabled = this.dealerOptions.length === 1;
              resolve();
            })
            .catch((err) => {
              this.isDisabled = true;
              reject();
            });
        });
      };

      if (initalLoad) return fetchDealers();

      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        return fetchDealers();
      }, 300);
    },
  },
};
</script>
